import React, { lazy } from "react";
import Page from "components/Page";
import { Props } from "./CashierActions";

const CashierActions = lazy(() => import("./CashierActions"));

export default (props: Props) => (
  <Page>
    <CashierActions {...props} />
  </Page>
);